module.exports = __webpack_public_path__ + "static/fullnamedisc-90313aa14ee8da4448a6c72e9aacb0f6.jpeg";